import Auth from "../auth/Auth";
import { ApiConfigCompany, BidNavVersion } from "../models/ApiConfigCompany";
import AppConfig from '../api/ApiConfig';
import ChangePasswordModel from "../models/ChangePasswordModel";
import LoginModel from "../models/LoginModel";
import { WebClient } from "./WebClient";

class ApiAuth extends WebClient {
    lasCompanyLocalStorageKey: string = "ccl.bidnav.admin.last.company";

    async login(creds: LoginModel): Promise<boolean> {
        try {
            const resp = await this.post("/auth/login", creds);
            if (resp.status === 200) {
                Auth.setAuthToken(resp.data);

                var company = AppConfig.getSelectedCompany();

                if (company.bidNavVersion == BidNavVersion.BidNav20) {
                    let lastCompanyId: string | null = null;
                    try {
                        lastCompanyId = localStorage.getItem(this.lasCompanyLocalStorageKey);
                    } catch { }
                    if (!!lastCompanyId) {
                        // this can change the auth token, so get static data after
                        await this.ChangeCompanyCode(lastCompanyId);
                    }
                }

                let currentToken = Auth.getAuthToken();
                await this.getStaticData(currentToken || "");

                return true;
            } else {
                return false;
            }
        } catch { return false; }
    }

    async getStaticData(authToken: string): Promise<boolean> {
        var company: ApiConfigCompany = AppConfig.getSelectedCompany();
        if (company.useStaticData == true) return true;

        try {
            const res = await this.get("/company/staticdata", authToken);
            if (res.status === 200) {
                company.bases = res.data.bases || company.bases;
                company.aircraft = res.data.aircraft || company.aircraft;
                company.positions = res.data.positions || company.positions;
                company.currency = res.data.currency || company.currency;
                company.currencyCode = res.data.currencyCode || company.currencyCode;
                company.defaultCountryCode = res.data.countryCode || company.defaultCountryCode;
                company.bidNavUrl = res.data.bnUrl || company.bidNavUrl;
                company.bnKey = res.data.bnKey || company.bnKey;
                company.useStaticData = true;
                return true;
            }
        } catch { }
        return false;
    }

    async logout(): Promise<boolean> {
        try {
            const res = await this.get("/auth/logout");
            Auth.deleteAuthToken();
            return res.status === 200;
        } catch {
            return false;
        }
        finally {
            Auth.deleteAuthToken();
        }
    }

    async updatePassword(pwds: ChangePasswordModel): Promise<boolean> {
        try {
            const resp = await this.put("/auth/pwd", pwds, Auth.getAuthToken());
            return resp.status === 200;
        } catch { return false; }
    }

    async ChangeCompanyCode(companyCode: string): Promise<boolean> {
        try {
            const resp = await this.get("/auth/company/" + companyCode, Auth.getAuthToken());
            if (resp.status === 200) {
                Auth.setAuthToken(resp.data);
                await this.getStaticData(resp.data);
                return true;
            } else {
                return false;
            }
        } catch { return false; }
    }

    async refreshStaticData() {
        var company: ApiConfigCompany = AppConfig.getSelectedCompany();
        if (!company.useStaticData) {
            try {
                let token = Auth.getAuthToken();
                let res: boolean = await this.getStaticData(token || "");
            } catch { }
        }
    }
}

export default new ApiAuth();

